module.exports = __webpack_public_path__ + "pc/img/main_work_img2.3665ccf7.jpg";